import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { id: "hamburger" }
const _hoisted_2 = ["checked"]
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<label class=\"menu-hamburger\" for=\"menu-toggle\"><svg width=\"45\" height=\"34\" stroke=\"#fff\" stroke-width=\"6\"><line x1=\"0\" y1=\"3\" x2=\"45\" y2=\"3\"></line><line x1=\"0\" y1=\"17\" x2=\"45\" y2=\"17\"></line><line x1=\"0\" y1=\"31\" x2=\"45\" y2=\"31\"></line></svg></label>", 1)
const _hoisted_4 = { class: "menu" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", {
  class: "menu-overlay",
  for: "menu-toggle"
}, null, -1)
const _hoisted_6 = { class: "menu-sidebar" }
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<div class=\"menu-header\"><label class=\"menu-hamburger\" for=\"menu-toggle\"><svg width=\"36\" height=\"36\" stroke=\"#333\" stroke-width=\"4\"><line x1=\"3\" y1=\"5\" x2=\"33\" y2=\"31\"></line><line x1=\"3\" y1=\"31\" x2=\"33\" y2=\"5\"></line></svg></label><h2>Menu</h2></div>", 1)
const _hoisted_8 = { key: 0 }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  key: 0,
  disabled: ""
}
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { key: 2 }
const _hoisted_13 = { key: 3 }
const _hoisted_14 = { key: 4 }

import {ref, inject} from 'vue';
	import {useRouter} from 'vue-router';
	import {FetchData} from "../utils/FetchData";
	import LoadingCircleAnimation from '../components/LoadingCircleAnimation.vue';

	const version = "0.1.0";

	
export default /*#__PURE__*/_defineComponent({
  __name: 'HamburgerMenu',
  setup(__props) {

	const checked = ref(false);
	const authorized = ref(false)
	const admin = ref(false);
	const router = useRouter();
	const showSeasons = ref(false);
	const seasons = ref([]);
	const loading = ref(true);

	const emitter = inject('emitter');
	emitter.on('unauthorized', () => onUnauthorized());
	emitter.on('authorized', () => onAuthorized());

	router.afterEach(() => {
		checked.value = false;

		if(localStorage.token != undefined)
			authorized.value = true;
		else
			authorized.value = false;
	});

	function onUnauthorized() {
		authorized.value = false;
		admin.value = false;
	}

	function onAuthorized() {
		authorized.value = true;
		const player = JSON.parse(localStorage.player);
		admin.value = player.isAdmin;
	}

	async function retrieveSeasons() {
		loading.value = true;
		const data = await FetchData("user/seasons");
		if(!data.isError)
			seasons.value = data.data;

		loading.value = false;
	}

	function toggleSeasons() {
		showSeasons.value = !showSeasons.value;
		if(seasons.value.length == 0)
			retrieveSeasons();
	}

	function selectSeason(season: object) {
		router.push({name: 'root', query: {season: season.id}});
	}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("nav", null, [
      _createElementVNode("input", {
        type: "checkbox",
        id: "menu-toggle",
        class: "menu-checkbox",
        checked: checked.value,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (checked.value = true))
      }, null, 8, _hoisted_2),
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("ul", null, [
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, { to: "/" }, {
                default: _withCtx(() => [
                  _createTextVNode("Startpagina")
                ]),
                _: 1
              })
            ]),
            (authorized.value)
              ? (_openBlock(), _createElementBlock("li", _hoisted_8, [
                  _createElementVNode("p", { onClick: toggleSeasons }, "Seizoenen"),
                  (showSeasons.value)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(seasons.value, (season) => {
                          return (_openBlock(), _createElementBlock("button", {
                            key: season.id,
                            onClick: ($event: any) => (selectSeason(season))
                          }, _toDisplayString(season.name), 9, _hoisted_9))
                        }), 128)),
                        (seasons.value.length == 0 && !loading.value)
                          ? (_openBlock(), _createElementBlock("button", _hoisted_10, "Geen seizoenen gevonden"))
                          : (loading.value)
                            ? (_openBlock(), _createBlock(LoadingCircleAnimation, {
                                key: 1,
                                width: "20"
                              }))
                            : _createCommentVNode("", true)
                      ], 64))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (authorized.value)
              ? (_openBlock(), _createElementBlock("li", _hoisted_11, [
                  _createVNode(_component_router_link, { to: "/leaderboard" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Ranglijst")
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            (admin.value)
              ? (_openBlock(), _createElementBlock("li", _hoisted_12, [
                  _createVNode(_component_router_link, { to: "/admin" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Admin")
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            (authorized.value)
              ? (_openBlock(), _createElementBlock("li", _hoisted_13, [
                  _createVNode(_component_router_link, { to: "/logout" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Uitloggen")
                    ]),
                    _: 1
                  })
                ]))
              : (_openBlock(), _createElementBlock("li", _hoisted_14, [
                  _createVNode(_component_router_link, { to: "/register" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Registreren")
                    ]),
                    _: 1
                  })
                ]))
          ]),
          _createElementVNode("p", { class: "version" }, "Versie " + _toDisplayString(version))
        ])
      ])
    ])
  ]))
}
}

})